module.exports = __webpack_public_path__ + "img/background_Image.ac979652.png";